//
// Module for the EDM Document Workflow Associations Edit view
//
rs.module("workflow/configuration/edmworkflowassociations/edit",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, ajaxUrls, constants) {

            // Unpack js selectors
            var form = $.js(jsSelectors.form);
            var edmDocumentSelect = form.js(jsSelectors.edmDocumentSelect);
            var workflowSelect = form.js(jsSelectors.workflowSelect);  
            var workflowStartOptionSelect = form.js(jsSelectors.workflowStartOptionSelect);  
            var workflowStartOptionHidden = form.js(jsSelectors.workflowStartOptionHidden); 
            var cancelButton = form.js(jsSelectors.cancelButton);

            // Get Select Helper for workflowStartOptionSelect
            var workflowStartOptionSelectHelper = selectHelper.getHelper(workflowStartOptionSelect);

            // Register edmDocumentSelect changed event
            edmDocumentSelect.change(edmDocumentChanged);

            // Register workflowSelect changed event
            workflowSelect.change(workflowChanged);

            // Handle dynamic display of fields on edmDocumentSelect changed
            function edmDocumentChanged() {

                $.getJSON(ajaxUrls.getCancelButtonUrl, { edmDocumentInfoKey: edmDocumentSelect.val() }).done(function (data) {

                    // Update the cancel button url which includes the newly select EDM Document
                    cancelButton.attr('href', data.indexUrl);
                });
            }

            // Handle dynamic display of fields on workflowSelect changed
            function workflowChanged() {

                $.getJSON(ajaxUrls.canStartWorkflowAsync, { hwfBaseDefinitionID: workflowSelect.val() }).done(function (data) {

                    if (data.canStartWorkflow) {
                        workflowStartOptionSelectHelper.setDisabled(false);

                        if (workflowStartOptionSelect.val() == constants.workflowStartNever) {
                            workflowStartOptionSelectHelper.setValue(constants.workflowStartAlways);
                        }

                        workflowStartOptionHidden.val("");
                    }
                    else {
                        workflowStartOptionSelectHelper.setDisabled(true);
                        workflowStartOptionSelectHelper.setValue(constants.workflowStartNever);
                        workflowStartOptionHidden.val(constants.workflowStartNever);
                    }
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);